module.exports = __webpack_public_path__ + "static/media/kredytomat.3ee5519a.png";